






















import Vue from 'vue'
import moment from 'moment'

import SequenceForm from '@/components/app/SequenceForm.vue'
import Axios from 'axios'

export default Vue.extend({
  name: "SequenceCreate",
  components: { SequenceForm },
  props: {
    related: {
      type: Boolean,
      default: false
    },
    resource: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      fields: [] as FormField[],
      id: null,
      loading: false,
      relatable: {},
      schema: [] as any[]
    }
  },

  methods: {
    async initData() {
      this.schema = await this.getSchema()
      this.initFields()
      this.schema.filter(field => field.display == "relationship").forEach(field => {
        this.$set(this.relatable, field.key, this.$store.state[field.key])
      })
    },
    async initFields() {
      this.fields = this.schema.map(field => {
        if (field.dataType === 'timestamp') {
          const value = field.defaultValue ? moment(field.defaultValue).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
          return Object.assign(field, {value})
        }
        return Object.assign(field, {value: field.defaultValue})
      })
    },
    async getSchema() {
      const schema = await this.$schema.get(this.resource)
      return schema
    },
    async submit(data) {
      this.loading = true
      try {
        const result = await Axios({
            data,
            headers: {
                authorization: `Bearer ${window.localStorage.getItem('idToken')}`
            },
            method: 'POST',
            url: '/generateSequences/'
        })
        window.console.log(result)
        this.success({
            message: "Sequences scheduled.",
            id: null,
            data: result.data
        })
      } catch (err) {
          if (err.response) {
              window.console.error(err)
              alert(err.response.message)
          }
        window.console.error(err)
        alert("An unexpected error occurred.")
      }
      this.loading = false
    },
    success(result) {
      alert(result.message)
      this.$emit('success', {action: "create", data: {...result.data, _id: result.id}, id: result.id, resource: this.resource})
    }
  },

  beforeCreate() {
    // @ts-ignore
    this.$options.components.ResourceCreate = require('./ResourceCreate.vue').default
  },

  async created() {
    this.initData()
  }
})
